import { systemApiURl } from "API/urls/system.api";
import { axiosInstance } from "configs/axios";

export const systemConfigApi = async () => {
  try {
    const response = await axiosInstance.get(systemApiURl.config);
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
